module.exports = "/_next/static/images/352edfe508c6fc2962fe0e0c560ccfcf-complexity@xs-2x.jpg.webp";